import type { PropsWithChildren } from 'react';

import { usePaginationStore } from '#pagination/context/hooks/store.hook';

import { PaginationContext } from './utilities/pagination.context';

/**
 * Provides the pagination context to its child components.
 *
 * This provider uses the `usePaginationStore` hook to supply the context value,
 * allowing any descendant component to access and interact with the pagination state.
 *
 * @param children - The child components that will have access to the pagination context.
 * @returns A context provider wrapping the given children.
 */
export const PaginationProvider = ({ children }: PropsWithChildren) => {
  return <PaginationContext.Provider value={usePaginationStore()}>{children}</PaginationContext.Provider>;
};
